import React, { useState } from "react";
import { useScheduleInterviews } from "../../contexts/ScheduleInterviewContext";
import ReusableTable from "../../components/UI/ReusableTable";
import Drawer from "../../components/UI/Drawer";
import CandidateDetails from "../../components/Details/CandidateDetails";
import Notification from "../../components/UI/Notification";
import ReactPaginate from 'react-paginate';
import { render } from "@testing-library/react";
import StatusBadge from '../../components/UI/StatusBadge';

const ScheduledInterviews = () => {
    const { interviews, fetchInterviews, updateInterviewStatus, pagination, loading } = useScheduleInterviews();
    const [selectedInterview, setSelectedInterview] = useState(null);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [notification, setNotification] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [isFiltering, setIsFiltering] = useState(false);

    const openDetailsDrawer = (interview) => {
        setSelectedInterview(interview);
        setIsDrawerOpen(true);
    };

    const closeDetailsDrawer = () => {
        setIsDrawerOpen(false);
        setSelectedInterview(null);
    };

    // Function to update interview status
    const handleStatusUpdate = async (feedback) => {
        if (!selectedInterview) return;
        
        // console.log("Updating status for:", selectedInterview.id, "with:", feedback);
    
        try {
            await updateInterviewStatus(selectedInterview.id, feedback);
            // setNotification("Interview status updated successfully.");
            setNotification({
                message: "Interview status updated successfully.",
                type: "success",
            });
            closeDetailsDrawer();
        } catch (error) {
            // setNotification("Error updating interview status:", error);
            setNotification({
                message: `Error updating interview status:, ${error}`,
                type: "error",
            });
            // console.error("Error updating interview status:", error);
        }
    };

    const getColumns = (currentPage, pageSize) => [
        { label: "Sr. No", field: "sr_no",
            render: (_row, idx) => (currentPage - 1) * pageSize + idx + 1,
        },
        {
            label: "Candidate Name",
            field: "candidate_name",
            render: (row) => (
                <button
                    onClick={() => openDetailsDrawer(row)}
                    className="text-blue-600 hover:underline hover:underline-offset-4"
                >
                    {row.candidate?.name || "Unknown Candidate"}
                </button>
            ),
        },
        { label: "Interviewer", field: "interviewer" },
        { 
            label: "Scheduled At", 
            field: "scheduled_at",
            render: (row) =>
                new Date(row.scheduled_at).toLocaleString("en-US", {
                    dateStyle: "medium",
                    timeStyle: "short",
                }),
        },
        { label: "Status", field: "status",
            render: (row) =>
            (
                <StatusBadge status={row?.status} />
            )
         },
    ];

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
          setCurrentPage(newPage);
          fetchInterviews(newPage);
        }
      };

    return (
        <div className="px-3 py-2 bg-white dark:bg-gray-900 font-poppins rounded-lg">
            
            {/* notification compo */}
            {notification && (
                <Notification message={notification.message} type={notification.type} onClose={() => setNotification(null)} />
            )}

            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
                <h2 className="text-2xl font-semibold text-gray-800 dark:text-white">Scheduled Interviews</h2>
            </div>

            {/* Scheduled Interviews Table */}
            <div>
                <ReusableTable
                    data={interviews}
                    // columns={columns}
                    columns={getColumns(currentPage, pagination.perPage)}
                    filterable={false}
                    loading={loading}
                    onFilterChange={(filtering) => setIsFiltering(filtering)}

                />

                {!isFiltering && interviews?.length > 0 && (
                <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next >"
                    onPageChange={(event) => handlePageChange(event.selected + 1)}
                    forcePage={currentPage - 1}
                    pageRangeDisplayed={5}
                    disabledClassName='opacity-50 cursor-not-allowed'
                    disabledLinkClassName='pointer-events-none'
                    pageCount={pagination.totalPages}
                    previousLabel="< Prev"
                    previousClassName='dark:text-white px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-100 dark:border-gray-600 dark:hover:bg-gray-800'
                    nextClassName="dark:text-white px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-100 dark:border-gray-600 dark:hover:bg-gray-800"
                    renderOnZeroPageCount={null}
                    containerClassName="flex items-center justify-center mt-4 font-poppins"
                    pageClassName="mx-1 px-3 py-1 border rounded dark:text-white font-poppins"
                    activeClassName="bg-blue-500 text-white dark:bg-black dark:text-white dark:border-gray-700 font-poppins"
                    />
                )}

            </div>

            {/* Drawer */}
            <Drawer
                isOpen={isDrawerOpen}
                onClose={closeDetailsDrawer}
                customWidth="w-3/5"
                ChilDiv=""
                ChildParent=""
                showClose = {false}
                border_radius="md:rounded-none"
            >
                {selectedInterview ? (
                    <CandidateDetails 
                        candidate={selectedInterview.candidate} 
                        interview={selectedInterview} 
                        onUpdateStatus={handleStatusUpdate} 
                        onClose={closeDetailsDrawer}
                    />
                ) : (
                    <p className="text-center text-gray-500"> </p>
                )}
            </Drawer>
        </div>
    );
};

export default ScheduledInterviews;
